module.exports = __webpack_public_path__ + "jab/media/folder.967fd55d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/folder.svg
// module id = 200
// module chunks = 0